module.exports = __webpack_public_path__ + "img/image4.1114507f.png";